import { printReportsURL } from "@app/constants/ApiEndPoints";
import axios from "axios";

export const getPrintHistoryWithPagination = async (page, perPage, sortField, sortDirection, search) => {
	try {
		const response = await axios.get(printReportsURL + `?page=${page}&perPage=${perPage}&sortField=${sortField}&sortDirection=${sortDirection}&franchiseId=${search.franchiseId}&kashflowOrderAccount=${search.kashflowOrderAccount}&month=${search.month}&year=${search.year}`);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getPrintReportDetailsByIdWithPagination = async (id, page, perPage, sortField, sortDirection, search) => {
	try {
		const params = new URLSearchParams();
		params.append('page', page);
		params.append('perPage', perPage);
		params.append('sortField', sortField);
		params.append('sortDirection', sortDirection);
		params.append('studentId', search.studentId || '');
		params.append('subjectId', search.subjectId || '');
		params.append('moduleId', search.moduleId || '');
		params.append('month', search.month || '');
		params.append('year', search.year || '');
		if (search.type?.length > 0) {
			search.type.forEach((t: string) => params.append('type[]', t));
		}
		const response = await axios.get(printReportsURL + `/${id}?${params.toString()}`);
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		return error?.response?.data;
	}
};


export const getExceededThresholdList = async (sortField, sortDirection, page, perPage, franchiseId, kashflowOrderAccount, month, year, type) => {
	try {
		const params = new URLSearchParams();
		params.append('sortField', sortField);
		params.append('sortDirection', sortDirection);
		params.append('page', page);
		params.append('perPage', perPage);
		params.append('franchiseId', franchiseId || '');
		params.append('kashflowOrderAccount', kashflowOrderAccount || '');
		params.append('month', month || '');
		params.append('year', year || '');
		if (type?.length > 0) {
			type.forEach((t: string) => params.append('type[]', t));
		}
		const response = await axios.get('/admin/students/print/summary/exceeded?' + params.toString());
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		return error?.response?.data;
	}
};


export const getExceededThresholdDetails = async (franchiseId, month, year, sortField, sortDirection, page, perPage) => {
	try {
		const params = new URLSearchParams();
		params.append('sortField', sortField);
		params.append('sortDirection', sortDirection);
		params.append('page', page);
		params.append('perPage', perPage);
		const response = await axios.get(`/admin/students/print/summary/exceeded/details/${franchiseId}?month=${month}&year=${year}&${params.toString()}`);
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		return error?.response?.data;
	}
};
